// @ts-nocheck
import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { TAXONOMY_CLIENT } from "../../utils/consts";
import VendorsQueryPayload from "../../types/taxonomy";
import { VENDOR_ID_QUERY } from "../../apis/taxonomy/queries";

interface Options {
  ids: Array<number>;
}

export const useMatchVendorsById = (options: Options) => {
  const { data, loading } = useQuery<VendorsQueryPayload>(VENDOR_ID_QUERY, {
    variables: {
      ids: options.ids,
    },
    skip: options.ids.length === 0,
    context: {
      clientName: TAXONOMY_CLIENT,
    },
  });

  const matchedVendorsById = useMemo(
    () => data?.vendor.data ?? [],
    [data?.vendor.data]
  );

  return {
    loading,
    matchedVendorsById,
  };
};
